import { KYMW9400Component } from './kymw9400.component';

/**
 * 外部システム連携画面の値を管理するクラス
 *
 * @export KYMW9400Model
 * @class KYMW9400Model
 */
export class KYMW9400Model {

  KYMW9400Component: KYMW9400Component;

  /**
   * 取り込むファイルの種類
   * 1:営業日カレンダー, 2:利用予算人数, 3:按分比率, 4:予算
   */
  public uploadType: string = <string>'';
}
